/* ---------------------------------
GLOBAL FUNCTIONS
---------------------------------*/

//Con esta función pasamos $6.500,12 a 650012. Valores de precio y de IVA.
function getPriceFromString(value, type = "default") {
  // Si el tipo es IVA, solo elimina los separadores de miles y la coma decimal
  if (type === "IVA") {
    let cleanValue = value.replace(/\./g, "").replace(",", ".");
    return parseFloat(cleanValue);
  }

  // Eliminar el símbolo de moneda y los puntos usados como separador de miles
  let cleanValue = value.replace(/[^\d,]/g, "").replace(/\./g, "");

  // Reemplazar la coma decimal por un punto para usar como separador decimal
  cleanValue = cleanValue.replace(",", ".");

  // Convertir a número
  return parseFloat(cleanValue);
}

//Con esta función pasamos 650012 a $6.500,12. Valores de precio y de IVA.
function getPriceFromNumber(value, type = "default") {
  // Redondear hacia abajo para obtener un número entero
  let roundedValue = Math.floor(value).toString();

  let formattedValue = roundedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  // Si el tipo es default, añadir el símbolo de $
  return type === "default" ? `$${formattedValue}` : formattedValue;
}

/* ---------------------------------
CHECKOUT PRODUCT
---------------------------------*/

class CheckOutProduct extends HTMLElement {
  constructor() {
    super();
    this.eraseBtn = this.querySelector("svg");
    this.minusBtn = this.querySelector(`#minus-${this.dataset.id}`);
    this.plusBtn = this.querySelector(`#plus-${this.dataset.id}`);
    this.qtyInput = this.querySelector(`#qty-${this.dataset.id}`);
    this.pricePerItem = this.getAttribute("price-per-item");
    this.totalPriceTag = this.querySelector(`#total-price-${this.dataset.id}`);
    this.whatsappButton = document.querySelector("#whatsapp-cart-button");
    this.toggleBtn = this.toggleBtn.bind(this);
    this.updateQty = this.updateQty.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
    this.updateUi = this.updateUi.bind(this);
    this.updateWhatsAppLink = this.updateWhatsAppLink.bind(this);

    this.minusBtn.addEventListener("click", () => this.updateQty(-1));
    this.plusBtn.addEventListener("click", () => this.updateQty(1));
    this.qtyInput.addEventListener("change", () => this.updateQty(0, true));
    this.eraseBtn.addEventListener("click", this.deleteItem);

    document.addEventListener("DOMContentLoaded", this.toggleBtn);
    document.addEventListener("cart:change", this.updateWhatsAppLink);
  }

  //Delta es la cantidad que se cambiara, isManual es false si se cambian los botones
  updateQty(delta, isManual = false) {
    let currentValue = Number(this.qtyInput.value);
    const maximumValue = Number(this.getAttribute("maximum-value"));
    const minimumValue = Number(this.getAttribute("minimum-value"));

    if (isManual) {
      // Cambio manual: validar si es decimal, mayor o menor a los límites
      if (currentValue % 1 !== 0) {
        currentValue = Math.floor(currentValue);
      }
    } else {
      // Cambio por botones: delta es +1 o -1
      currentValue += delta;
    }

    // Validar límites
    if (currentValue < minimumValue) {
      currentValue = minimumValue;
    }
    if (currentValue > maximumValue) {
      currentValue = maximumValue;
    }

    // Actualizar el valor del input
    this.qtyInput.value = currentValue;

    // Habilitar o deshabilitar botones
    this.toggleBtn();

    // Actualizar el carrito y el enlace de WhatsApp
    this.fetchUpdateCart(this.getAttribute("variant-id"), currentValue);
    this.updateWhatsAppLink();
  }

  // Actualizar el enlace de WhatsApp con las cantidades actuales
  updateWhatsAppLink() {
    const cartItems = document.querySelectorAll("checkout-product");
    const whatsappButton = document.querySelector("#whatsapp-cart-button");
    const introMessage = whatsappButton.getAttribute("data-msg-1");
    const outroMessage = whatsappButton.getAttribute("data-msg-2"); 
    const phone = whatsappButton.getAttribute("data-phone");

    let message = "";

    cartItems.forEach((item) => {
      const title = item.querySelector("p").textContent.trim(); 
      const quantity = item.querySelector(`#qty-${item.dataset.id}`).value; 

      message += `- ${title} x ${quantity}\n`; 
    });

    // Generar el nuevo enlace
    const newHref = `https://api.whatsapp.com/send?phone=+57${phone}&text=${encodeURIComponent(
      introMessage
    )}%0A%0A${encodeURIComponent(message)}%0A${encodeURIComponent(outroMessage)}`;
    
    // Actualizar el href del botón
    this.whatsappButton.href = newHref;
  }

  async deleteItem() {
    const lineitemId = this.getAttribute("variant-id");
    try {
      // Fetch cart items to find the item with this variant-id and its UID
      const cartItems = await this.getCartItems();
      
      // Find the line item matching the variantId
      const currentItem = cartItems.items.find(item => item.id == lineitemId);
      
      if (currentItem) {
        const uid = currentItem.properties && currentItem.properties.uid; // Assuming the UID is stored in properties
        
        if (uid) {
          // Find all items in the cart that match this UID
          const matchingItems = cartItems.items.filter(item => item.properties && item.properties.uid === uid);
          console.log('Matching items:', matchingItems);
          // Remove all matching items
          for (const item of matchingItems) {
            const checkoutItem = this.parentNode.querySelector(`[variant-id="${item.id}"]`)
            checkoutItem.classList.add("hidden")
            await this.fetchUpdateCart(String(item.key), 0); // Delete item by line item key
          }
        } else {
          await this.fetchUpdateCart(String(currentItem.key), 0, false); // Delete item by line item key
        }
  
        // Hide the UI element after removing the items
        this.classList.add("hidden");
      } else {
        console.log('Item with variant-id not found in the cart');
      }
      await this.updateUi();
    } catch (error) {
      console.log('Error deleting item:', error);
    }
  }
  
  async getCartItems() {
    try {
      const response = await fetch(`${Shopify.routes.root}cart.js`);
      if (!response.ok) throw new Error('Failed to fetch cart items');
      const cartData = await response.json();
      return cartData;
    } catch (error) {
      console.log('Error fetching cart items:', error);
    }
  }

  async fetchUpdateCart(id, quantity, reload = true) {
    const newObj = {
      id,
      quantity,
    };

    try {
      // First, get the current cart state
      const cartResponse = await fetch(`${Shopify.routes.root}cart.js`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      const cart = await cartResponse.json();

      // Find the item with the specified 'id' in the cart to get the 'uid' property
      const currentItem = cart.items.find(item => item.id == parseInt(id));

      console.log('Current item:', currentItem);

      if (currentItem && currentItem.properties && currentItem.properties.uid) {
        const currentUid = currentItem.properties.uid;

        // Look through the cart for other products with the same 'uid' property
        const matchingItems = cart.items.filter(item => {
          if (item.properties && item.properties.uid) {
            return item.properties.uid === currentUid && item.id !== id;
          }
          return false;
        });

        // If we found any matching items, update their quantities if they don't have the "incluye-cantidad" tag or if quantity is 0
        for (const matchingItem of matchingItems) {
          // Fetch product details to check tags
          const productResponse = await fetch(`/products/${matchingItem.handle}.js`);
          const productData = await productResponse.json();

          if (!productData.tags.includes("incluye-cantidad") || quantity === 0) {
            await fetch(`${Shopify.routes.root}cart/change.js`, {
              body: JSON.stringify({
                id: String(matchingItem.id),
                quantity: quantity, // Update the quantity of the matching item
              }),
              method: "POST",
              headers: { "Content-Type": "application/json" },
            });
          }
        }
      }

      // Now update the quantity of the original item if it doesn't have the "incluye-cantidad" tag or if quantity is 0
      if (id) {
        // Fetch product details to check tags
        const productResponse = await fetch(`/products/${currentItem.handle}.js`);
        const productData = await productResponse.json();

        if (!productData.tags.includes("incluye-cantidad") || quantity === 0) {
          await fetch(`${Shopify.routes.root}cart/change.js`, {
            body: JSON.stringify(newObj),
            method: "POST",
            headers: { "Content-Type": "application/json" },
          });

          if (reload) this.updateUi();
        }
      }
    } catch (error) {
      console.log(error);
    }
  }


  updateUi = async () => {
    const response = await fetch(`${Shopify.routes.root}cart.js`);
    const cart = await response.json();
    
    const numberPricePerItem = getPriceFromString(this.pricePerItem);
    const updatedPrice = numberPricePerItem * Number(this.qtyInput.value);

    const emptyContainer = document.querySelector("#empty-cart-section");
    const fullContainer = document.querySelector("#full-cart-section");
    if (!cart.items.length && emptyContainer.classList.contains("hidden")) {
      emptyContainer.classList.remove("hidden");
      fullContainer.classList.add("hidden");
    }

    this.totalPriceTag.innerText = getPriceFromNumber(updatedPrice);
    const relatedMarcado = document.querySelectorAll(`[data-uid="${this.dataset.uid}"]`)[1];
    const productResponse = await fetch(`/products/${relatedMarcado.dataset.product}.js`);
    const productData = await productResponse.json();
    if (relatedMarcado && !productData.tags.includes("incluye-cantidad") || this.qtyInput.value === "0") {
      relatedMarcado.querySelector(".cart-total-price").innerText = getPriceFromNumber(getPriceFromString(relatedMarcado.getAttribute("price-per-item")) * Number(this.qtyInput.value));
    }
    updateReviewSection();

    //cart es el carrito actualizado, openCart dice si abrir el menú de carrito o no.
    this.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        cart,
        detail: {
          cart,
          openCart: false,
        },
      })
    );
  };

  toggleBtn() {
    const maximumValue = Number(this.getAttribute("maximum-value"));
    const minimumValue = Number(this.getAttribute("minimum-value"));
    if (Number(this.qtyInput.value) === maximumValue) {
      this.plusBtn.disabled = true;
    } else {
      this.plusBtn.disabled = false;
    }
    if (Number(this.qtyInput.value) === minimumValue) {
      this.minusBtn.disabled = true;
    } else {
      this.minusBtn.disabled = false;
    }
  }
}

customElements.define("checkout-product", CheckOutProduct);

/* ---------------------------------
REVIEW SECTION
---------------------------------*/

//Con esta función actualizamos la sección de review
function updateReviewSection() {
  //Seleccionamos el iva total, el total sin iva, y el total + iva.
  const totalWithoutIva = document.querySelector("#review-cart-total-items");
  const totalIva = document.querySelector("#review-cart-iva");
  const total = document.querySelector("#review-cart-total");
  //Extraemos el porcentaje de IVA y cada uno de los precios del carrito
  const ivaPercentage = totalIva.dataset.iva;
  const allTotalPrices = document.querySelectorAll(".cart-total-price");

  //accPrice será el precio acumulado de todos los items
  let accPrice = 0;
  allTotalPrices.forEach((price) => {
    const container = price.closest("checkout-product");
    if (!container.classList.contains("hidden")) {
      const numberPrice = getPriceFromString(price.innerText);
      accPrice += numberPrice;
    }
  });

  //Actualizamos los valores
  const updatedIva = accPrice * (Number(ivaPercentage) / 100);

  totalWithoutIva.innerText = getPriceFromNumber(accPrice);
  totalIva.innerText = getPriceFromNumber(updatedIva);
  total.innerText = getPriceFromNumber(accPrice + updatedIva);
}

const optionalNotes = document.querySelector("#review-message");
const sendToCheckoutBtn = document.querySelector("#sendToCheckout");

sendToCheckoutBtn?.addEventListener("click", addNotes);

async function addNotes(e) {
  e.preventDefault();
  const note = optionalNotes.value;
  if (!note) {
    return window.location.href = e.target.href;
  }

  try {
    const res = await fetch(`${Shopify.routes.root}cart/update.js`, {
      body: JSON.stringify({ note }),
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });

    const data = await res.json();
    window.location.href = e.target.href;
  } catch (error) {
    console.log(error);
  }
}

/* ---------------------------------
RELATED PRODUCTS
---------------------------------*/

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.loadRecommendations(this.dataset.productId);
  }

  async loadRecommendations(productId) {
    try {
      const res = await fetch(
        `/recommendations/products.json?limit=5&product_id=${productId}&section_id=${this.dataset.sectionId}`
      );
      const text = await res.text();
      /* this.innerHTML = text; */
    } catch (error) {
      console.error(e);
    }
  }
}

customElements.define("product-recommendations", ProductRecommendations);
